export default "__VITE_ASSET__ClZNH0$y__"